import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import campaignContext from 'common/src/modules/campaigns/copilot/contexts/campaignContext';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {CLStore} from 'common/src/redux/store';
import {SkillName} from '../skills.enums';

function socialCampaignSetupSkill(store: CLStore) {
  return skill({
    name: SkillName.SocialCampaignSetup,
    description:
      'Helps users configure social media advertising campaigns across various platforms',
    whenToUse:
      'Setting up and configuring social media advertising campaigns. Handles social campaign configuration across platforms including Facebook, YouTube, TikTok, Snapchat, and LinkedIn. Can help create and manage ad sets for social campaigns.',
    whenToAvoid:
      'Non-social (programmatic/display) campaign setup, campaign analytics, or decision tree logic.',
    instructions:
      'You are a social campaign setup specialist that helps users configure social media advertising campaigns across various platforms including Facebook, YouTube, TikTok, Snapchat, and LinkedIn.',
    tools: [],
    contextBuilders: [campaignContext(store)],
    applicableBreadcrumbs: [BreadcrumbName.CampaignPage],
  });
}

export default socialCampaignSetupSkill;
